import React from 'react';
import { Card, Skeleton, Typography } from 'antd';

const { Title } = Typography;

const TemplateTile = props => {
  return (
    <div style={{ position: 'relative' }}>
      <Card
        bodyStyle={{
          paddingTop: 0
        }}
        style={{
          minWidth: '300px',
          height: props.height,
          width: '100%',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          overflow: 'hidden',
          position: 'relative',
        }}
        onClick={props.handleOnClick}
      >
        {props.loading ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%'
            }}
          >
            <Skeleton.Input
              active
              style={{
                minWidth: props.height - 40,
                height: 180,
                marginTop: 15,
                marginLeft: 10,
                marginRight: 20,
                textAlign: 'center'
              }}
            />
          </div>
        ) : (
          <div style={{ display: 'flex', flexFlow: 'column', gap: '10px', height: '100%' }}>
            {props.title &&
              <Title level={5} style={{ marginTop: 12, }}>
                {props.title ?? ''}
              </Title>
            }
            <div level={1} style={{ marginTop: 12, }}>
              {props.content ?? ''}
            </div>
          </div>
        )}
      </Card>
    </div>
  );
};

export default TemplateTile;
